import sha256 from "crypto-js/sha256";
import stringify from "json-stable-stringify";

export default function hash(string2Hash) {
  return sha256(stringify(string2Hash)).toString();
}
